import { defineComponent as _defineComponent } from 'vue'
import CcDropdown from '@/views/Automation/CampaignCreatorV2/components/CcDropdown/CcDropdown.ts.vue';
import CcIcon from '@/views/Automation/CampaignCreatorV2/components/CcIcon/CcIcon.ts.vue';
import { ref } from 'vue';

export type DropdownOption = {
  id: string;
  label: string;
  disabled?: boolean;
  description?: string;
  type: string;
  options?: Array<DropdownOption>;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'CcDropdown.ts',
  props: {
    options: null
  },
  emits: ["select"],
  setup(__props: any, { emit: emits }: { emit: ({ (e: 'select', value: DropdownOption): void }), expose: any, slots: any, attrs: any }) {

// TODO check if needed
// eslint-disable-next-line import/no-self-import



const openedGroups = ref<string[]>([]);

function toggleGroup(option: DropdownOption) {
  if (option.disabled) return;

  const index = openedGroups.value.findIndex((groupId) => groupId === option.id);
  if (index === -1) {
    openedGroups.value.push(option.id);
  } else {
    openedGroups.value.splice(index, 1);
  }
}

function selectOption(option: DropdownOption) {
  if (option.disabled) return;
  emits('select', option);
}

return { __sfc: true,emits, openedGroups, toggleGroup, selectOption, CcDropdown, CcIcon }
}

})